"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleFiltersDropdown = exports.toggleOrderByDropdown = exports.unselectItems = exports.selectItems = exports.setFilterBy = exports.fetchCustomerListFailed = exports.fetchCustomerListSuccess = exports.fetchCustomerListRequest = void 0;
const ActionTypes = require("../../actionTypes/customer/list");
const fetchCustomerListRequest = (type, opts) => ({
    type: ActionTypes.FETCH_CUSTOMER_LIST_REQUEST,
    payload: {
        type,
        opts
    }
});
exports.fetchCustomerListRequest = fetchCustomerListRequest;
const fetchCustomerListSuccess = (type, customers) => ({
    type: ActionTypes.FETCH_CUSTOMER_LIST_SUCCESS,
    payload: {
        type,
        customers
    }
});
exports.fetchCustomerListSuccess = fetchCustomerListSuccess;
const fetchCustomerListFailed = (error) => ({
    type: ActionTypes.FETCH_CUSTOMER_LIST_FAILED,
    payload: error
});
exports.fetchCustomerListFailed = fetchCustomerListFailed;
const setFilterBy = (filterBy) => ({
    type: ActionTypes.SET_FILTER_BY,
    payload: filterBy
});
exports.setFilterBy = setFilterBy;
const selectItems = (selected) => ({
    type: ActionTypes.SELECT_ITEMS,
    payload: selected
});
exports.selectItems = selectItems;
const unselectItems = (unselected) => ({
    type: ActionTypes.UNSELECT_ITEMS,
    payload: unselected
});
exports.unselectItems = unselectItems;
const toggleOrderByDropdown = () => ({
    type: ActionTypes.TOGGLE_SORT_BY_DROPDOWN
});
exports.toggleOrderByDropdown = toggleOrderByDropdown;
const toggleFiltersDropdown = () => ({
    type: ActionTypes.TOGGLE_FILTERS_DROPDOWN
});
exports.toggleFiltersDropdown = toggleFiltersDropdown;
//# sourceMappingURL=list.js.map